module.exports = __webpack_public_path__ + "img/link-handbook-desktop_jp.ea344c7.jpg";